import {
	TIMELINE_LIST_ACTION_TYPES,
	TimelineActionTypes,
	TimeLineListState,
} from '../../../../types/timeline'

const initialState: TimeLineListState = {
	timelineList: [],
	count: 0,
}

export default (
	state = initialState,
	action: TimelineActionTypes
): TimeLineListState => {
	switch (action.type) {
		case TIMELINE_LIST_ACTION_TYPES.TIMELINE_LIST_GET: {
			return {
				...state,
				timelineList: action.payload?.paginatedResults,
				count: action.payload?.totalCount?.[0]?.count || 0,
			}
		}

		case TIMELINE_LIST_ACTION_TYPES.TIMELINE_LIST_GET_MORE: {
			const newTimeline = action.payload?.paginatedResults || []

			const updatedTimelineList = [
				...new Map(
					[...state.timelineList, ...newTimeline].map(el => [
						el._id,
						el,
					])
				).values(),
			]

			return {
				...state,
				timelineList: updatedTimelineList,
			}
		}
		default: {
			return state
		}
	}
}
